package com.essntl.features.invoice.data.supabase

import com.essntl.features.invoice.domain.model.InvoiceModel
import core.dateformat.utils.fromDDTOMM
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

fun InvoiceModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    updatedBy?.let { updatedBy ->
        requestMap["updated_by"] = JsonPrimitive(updatedBy)
    }

    paymentLinkIds?.let { proposalServices ->
        requestMap["payment_link_ids"] = JsonArray(proposalServices.map { JsonPrimitive(it) })
    }

    proposalServiceIds?.let { proposalServices ->
        requestMap["proposal_services"] = JsonArray(proposalServices.map { JsonPrimitive(it) })
    }

    itineraryServiceIds?.let { itineraryServices ->
        requestMap["itinerary_services"] = JsonArray(itineraryServices.map { JsonPrimitive(it) })
    }

    extraServiceIds?.let { extraServiceIds ->
        requestMap["extra_service_ids"] = JsonArray(extraServiceIds.map { JsonPrimitive(it) })
    }

    qbId?.let { qbId ->
        requestMap["qb_id"] = JsonPrimitive(qbId)
    }

    dueDate?.let { dueDate ->
        requestMap["due_date"] = JsonPrimitive(fromDDTOMM(dueDate))
    }

    proposalId?.let { proposalId ->
        requestMap["proposal_id"] = JsonPrimitive(proposalId)
    }

    return requestMap
}
